import {jwtDecode} from 'jwt-decode';

// Reads the signed-in role from the stored access token without touching the session.
export function sessionRole() {
    try {
        const token = jwtDecode(localStorage.getItem('cosToken') || '');
        if (!Number.isFinite(token.exp) || token.exp * 1000 <= Date.now()) return null;
        return token.optinestUser?.optinestApiUser?.role || null;
    } catch {
        return null;
    }
}

export function isAdminSession() {
    return sessionRole() === 'ADMIN';
}
